import { cn } from "../../../../../../utils/cn"

type Props = {
  title: string
  subTitle?: string
  number: string | number
  unit: string
  containerClassName?: string
  valueClassName?: string
}

export const NumberAndUnit = ({ title, subTitle, number, unit, containerClassName, valueClassName }: Props) => {
  return (
    <div className={containerClassName}>
      <div className="text-sm font-normal tracking-tighter text-[#333333]" style={{ fontFeatureSettings: '"palt"' }}>
        <span className="text-xs font-[600]">{title}</span>
        {subTitle && (
          <span className="text-xs text-[#4d4d4d]" style={{ fontFeatureSettings: "normal" }}>
            （{subTitle}）
          </span>
        )}
      </div>
      <div
        className={cn(
          "rounded border border-solid px-1.5 py-0.5 text-right text-sm leading-7 text-[#c50d12]",
          valueClassName,
        )}
      >
        <span className="text-lg font-bold">{number}</span>
        <span className="text-xs font-bold">{unit}</span>
      </div>
    </div>
  )
}

export default NumberAndUnit
